import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';
import contactReducer from './slices/contactSlice';
import contactCategoryReducer from './slices/contactCategorySlice';
import templateReducer from './slices/templateSlice';
import campaignReducer from './slices/campaignSlice';
import userReducer from './slices/userSlice';
import userStatsReducer from './slices/userStatsSlice';
import footerReducer from './slices/footerSlice';
import activityLogReducer from './slices/activityLogSlice';
import gmailReducer from './slices/gmailSlice';
import chatReducer from './slices/chatSlice';

const store = configureStore({
  reducer: {
    auth: authReducer,
    contacts: contactReducer,
    contactCategories: contactCategoryReducer,
    templates: templateReducer,
    campaigns: campaignReducer,
    users: userReducer,
    userStats: userStatsReducer,
    footers: footerReducer,
    activityLogs: activityLogReducer,
    gmail: gmailReducer,
    chat: chatReducer
  }
});

export default store;
